module.exports = __webpack_public_path__ + "static/media/translations0.7e1b2592.jpg";